import { bankAbbr } from "../lib/api";
import { Area, AreaChart, Bar, BarChart, CartesianGrid, Cell, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

const tip = { contentStyle: { background: "#040606", border: "1px solid #222D2B", borderRadius: 2, fontFamily: "JetBrains Mono", fontSize: 11 }, labelStyle: { color: "#888" } };
const axis = { stroke: "#444", fontSize: 10, fontFamily: "JetBrains Mono", tickLine: false, axisLine: false };

export const WinRateChart = ({ data }) => (
  <div className="h-64" data-testid="win-rate-chart">
    <ResponsiveContainer>
      <AreaChart data={data} margin={{ left: -20, right: 8, top: 8 }}>
        <defs>
          <linearGradient id="wr" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="var(--brand)" stopOpacity={0.35} />
            <stop offset="100%" stopColor="var(--brand)" stopOpacity={0} />
          </linearGradient>
        </defs>
        <CartesianGrid stroke="#101716" vertical={false} />
        <XAxis dataKey="month" {...axis} />
        <YAxis {...axis} />
        <Tooltip {...tip} />
        <Area type="monotone" dataKey="opened" stroke="#37E5D7" strokeWidth={1.5} fill="transparent" name="Opened" />
        <Area type="monotone" dataKey="won" stroke="var(--brand)" strokeWidth={2} fill="url(#wr)" name="Won" />
        <Area type="monotone" dataKey="lost" stroke="#F87171" strokeWidth={1.5} fill="transparent" name="Lost" />
      </AreaChart>
    </ResponsiveContainer>
  </div>
);

const PALETTE = ["var(--brand)", "var(--accent2)", "#7000FF", "#FFB800", "#F87171", "#3DFFB0", "#5C7CFF", "#888"];

export const ReasonChart = ({ data }) => (
  <div className="h-56" data-testid="reason-chart">
    <ResponsiveContainer>
      <BarChart data={data} layout="vertical" margin={{ left: 20, right: 12 }}>
        <XAxis type="number" hide />
        <YAxis type="category" dataKey="label" width={150} {...axis} stroke="#888" />
        <Tooltip {...tip} cursor={{ fill: "rgba(255,255,255,0.03)" }} />
        <Bar dataKey="count" barSize={10} radius={[0, 2, 2, 0]}>
          {data.map((_, i) => <Cell key={i} fill={PALETTE[i % PALETTE.length]} />)}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  </div>
);

export const BankScoreChart = ({ data }) => (
  <div className="h-56" data-testid="bank-score-chart">
    <ResponsiveContainer>
      <BarChart data={data.map((b) => ({ ...b, rate: Math.round(b.win_rate * 100) }))} margin={{ left: -20, right: 8 }}>
        <CartesianGrid stroke="#101716" vertical={false} />
        <XAxis dataKey="name" {...axis} interval={0} tickFormatter={bankAbbr} />
        <YAxis {...axis} domain={[0, 100]} />
        <Tooltip {...tip} cursor={{ fill: "rgba(255,255,255,0.03)" }} formatter={(v) => `${v}%`} />
        <Bar dataKey="rate" name="Win rate" barSize={18} radius={[2, 2, 0, 0]}>
          {data.map((b, i) => <Cell key={i} fill={b.win_rate >= 0.6 ? "#CCFF00" : b.win_rate >= 0.45 ? "#FFB800" : "#F87171"} />)}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  </div>
);
